/**
 * Shared, single-source-of-truth descriptions for campaign metrics. Used by the
 * info ("i") dialogs on metric cards and data-table headers so the same metric
 * always explains itself the same way.
 */
export const METRIC_INFO = {
  impressions: 'Total number of times your ads were displayed, including repeated views by the same buyer.',
  reach: 'Number of unique buyers who saw your ads at least once.',
  clicks: 'Total number of clicks received on your ads, including repeated clicks by the same buyer.',
  ctr: 'Percentage of impressions that resulted in a click, calculated as Total Clicks ÷ Impressions × 100.',
  plays: 'Total number of times buyers played your promoted beats, including repeated plays.',
  addToCart: 'Total ATCs actions initiated by your ads, including multiple beats or repeated actions by the same buyer.',
  checkouts: 'Total checkouts initiated by your ads, including repeated attempts by the same buyer.',
  revenue: 'Total revenue initiated from purchases attributed to your ad campaigns.',
} as const;

/**
 * The metric definitions as an ordered list, used by the shared "Learn Terms"
 * button/popup so every campaign screen explains the same terms the same way.
 */
export const METRIC_GLOSSARY: Array<{ label: string; message: string }> = [
  { label: 'Impressions', message: METRIC_INFO.impressions },
  { label: 'Reach', message: METRIC_INFO.reach },
  { label: 'Total Clicks', message: METRIC_INFO.clicks },
  { label: 'CTR%', message: METRIC_INFO.ctr },
  { label: 'Total Plays', message: METRIC_INFO.plays },
  { label: 'ATCs', message: METRIC_INFO.addToCart },
  { label: 'Checkouts', message: METRIC_INFO.checkouts },
  { label: 'Revenue', message: METRIC_INFO.revenue },
];
